import { createApi } from '@reduxjs/toolkit/query/react';

import issQuery from './issQuery';
import { Bulletin } from './models/BulletinModel';

export const bulletinApi = createApi({
    reducerPath: 'bulletinApi',
    baseQuery: (args, api, extraOptions) => {
        return issQuery('/customer-bulletin/api/v1', {})(args, api, extraOptions);
    },
    tagTypes: ['Data'],
    endpoints: (builder) => ({
        fetchBulletins: builder.query<Bulletin[], void>({
            query: () => '/articles',
            providesTags: ['Data'],
        }),
        fetchBulletin: builder.query<Bulletin, number>({
            query: (id) => `/articles/${id}`,
        }),
    }),
});
export const { useFetchBulletinsQuery, useFetchBulletinQuery, useLazyFetchBulletinQuery } =
    bulletinApi;